export default __webpack_public_path__ + "static/media/yuhmak.ae69f43f.png";